(function () {
    'use strict';

    angular
        .module('physicalFairs')
        .controller('VirtualFairStudentsPhonesController', VirtualFairStudentsPhonesController);

        VirtualFairStudentsPhonesController.$inject = ['VirtualFairService','$timeout'];


    function VirtualFairStudentsPhonesController(VirtualFairService, $timeout) {
        var vm = this;

        vm.flag                     = false;
        vm.expo                     = [];
        vm.expoSelected             = '';
        vm.selectExpo               = selectExpo;
        vm.getByFilter              = getByFilter;
        vm.downloadCSV              = downloadCSV;
        

        /* PAGINATION */
        vm.pageChanged = pageChanged;
        vm.setPage = setPage;
        vm.to = [];
        vm.totalItems = [];
        vm.currentPage = null;
        vm.itemsPerPage = [];
        vm.page = 1;

        function activate() {
            vm.selectExpo();
        }

        function selectExpo () {
            VirtualFairService.getAll().then(function(response){
                vm.expo = response.data;
            });
        }

        function getByFilter() {
            vm.flag = false;
            vm.query = {};
            vm.query['expo_id']         = vm.expoSelected.id;
            if (vm.page !== null) {
                vm.query['page'] = vm.page;
            }
            VirtualFairService.getStudentsPhones(vm.query).then(function(response){
                vm.response = response.data.data;
                if (vm.response.length === 0) {
                    vm.noResultMessage = 'Sorry, no results were found!';
                    vm.flag = false;
                } else {
                    vm.noResultMessage = '';
                    vm.flag = true;
                }
                vm.totalItems = response.data.total;
                vm.to = response.data.to;
                vm.setPage(response.data.current_page);
                vm.itemsPerPage = response.data.per_page;
            });
        }

        function setPage(pageNo) {
            vm.currentPage = pageNo;
        }

        function pageChanged() {
            vm.page = vm.currentPage;
            vm.getByFilter();
        }

        function downloadCSV() {

            vm.query = {};
            vm.query['expo_id']         = vm.expoSelected.id;
            VirtualFairService.getStudentsPhonesCsv(vm.query).success(function (data, status, headers, config) {
                var anchor = document.createElement('a');
                anchor.href = 'data:attachment/csv;charset=utf-8,' + encodeURI(data);
                anchor.target = '_blank';
                anchor.download = `virtual_fair_students_phones_${vm.expoSelected.id}.csv`;
                document.body.appendChild(anchor);
                anchor.click();
                $timeout(function () {
                    anchor.remove();
                }, 50);
            });
        }

        
        activate();

    }

})();